import * as Yup from 'yup';
import { ClientBusinessModel } from 'app/client/clientBusiness/models/ClientBusiness';
import {
  transferReservationBaseFormValidation,
  transferReservationBaseLocationFormValidation
} from '../base/TransferReservationBaseFormValidation';
import {
  TIPOS_SERVICIO_VIAJE_TRASLADO,
  ViajeTrasladoTipoServicio
} from '../../models';

export const transferReservationSingleLocationFormValidation =
  transferReservationBaseLocationFormValidation;

export const transferReservationSingleFormValidation = (
  cliente: ClientBusinessModel | undefined,
  isLLTPais: boolean,
  withPhoneValidation?: boolean | undefined
) =>
  transferReservationBaseFormValidation(cliente, withPhoneValidation).shape({
    tipoServicio: Yup.mixed()
      .required('El tipo de servicio es obligatorio')
      .oneOf(TIPOS_SERVICIO_VIAJE_TRASLADO),
    bus_type_id: Yup.mixed().when('tipoServicio', {
      is: ViajeTrasladoTipoServicio.SERVICIOS_GRUPALES,
      then: (schema) => schema.required('El tipo de bus es requerido'),
    }),
    bus_customer_price: Yup.mixed().when('tipoServicio', {
      is: ViajeTrasladoTipoServicio.SERVICIOS_GRUPALES,
      then: (schema) =>
        schema.required('El costo del cliente es requerido'),
    }),
    bus_provider_price: Yup.mixed().when('tipoServicio', {
      is: ViajeTrasladoTipoServicio.SERVICIOS_GRUPALES,
      then: (schema) =>
        schema.required('El costo del proveedor es requerido'),
    }),
    prioridad: Yup.boolean(),
    hasOutSite: Yup.boolean(),
    puntos: Yup.array()
      .min(2, 'Debe haber al menos dos puntos')
      .of(transferReservationSingleLocationFormValidation),
    fechaYHoraDeLlegada: Yup.mixed().required(
      'La fecha de llegada es requerida'
    ),
    minutosPreviosASalida: Yup.mixed().required(
      'Los minutos de salida son requeridos'
    ),
    providerPrice: isLLTPais
      ? Yup.number().required('El costo del proveedor es requerido')
      : Yup.number().nullable(),
    customerPrice: isLLTPais
      ? Yup.number().required('El costo del cliente es requerido')
      : Yup.number().nullable()
  });
